var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplicity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1321317831"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.991 18.1141L23.2706 32.8435L21.6256 34.4885C20.6011 35.5135 18.9278 35.5135 17.9033 34.4885L9.50902 26.0947C8.54061 25.1263 8.54061 23.5567 9.50902 22.5883C10.4774 21.6199 12.047 21.6199 13.0154 22.5883L19.7551 29.328L34.4755 14.6076C35.4439 13.6392 37.0135 13.6392 37.9819 14.6076C38.9594 15.576 38.9594 17.1457 37.991 18.1141Z",
    fill: "#13373F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplicity);
export default __webpack_public_path__ + "static/media/Simplicity.e6c9197927541639ad6c53593fa7a82b.svg";
export { ForwardRef as ReactComponent };